// @flow

import { Component } from '../jsti/core';
import EventNames from '../constants/EventNames';
import Notifications from '../constants/Notifications';

export default class SearchCancel extends Component {
  #clickHandler: function;

  /**
   * Initialize the component
   *
   * @param pEl
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);

    this.#clickHandler = this.onClick.bind(this);
    this.addEventListener(EventNames.CLICK, this.#clickHandler);
  }

  /**
   * Executes when the user clicks the element
   */
  onClick(): void {
    this.notify(Notifications.HIDE_SEARCH_SUGGESTIONS);
  }

  /**
   * Remove all event listeners
   */
  destroy() {
    this.removeEventListener(EventNames.CLICK, this.#clickHandler);
    super.destroy();
  }
}
